import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import axios from 'axios'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './ForgotPassword.css'

const LOGO_URL = 'https://res.cloudinary.com/dk50cmtps/image/upload/v1786338929/unnamed_efi40j.png'
const LOGO_SIDE_IMG_URL = 'https://res.cloudinary.com/dk50cmtps/image/upload/v1786336638/592f1aee-a328-4135-bd3f-8a1e20477346_smm1fr.png'

// const API_BASE_URL = 'https://upskledbackend.vercel.app'
const API_BASE_URL = 'https://upskld.co/api'

const forgotSchema = Yup.object({
  email: Yup.string()
    .trim()
    .email('Enter a valid email address')
    .required('Email is required'),
})

const ForgotPassword = () => {
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSent, setIsSent] = useState(false)
  useEffect(() => {
    document.querySelector("#root").scrollIntoView({ behavior: "smooth" });
  }, []);
  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: forgotSchema,
    onSubmit: async (values) => {
      setIsSubmitting(true)
      try {
        const response = await axios.post(`${API_BASE_URL}/forgot-password`, {
          email: values.email,
        })

        if (response.data.success) {
          toast.success(response.data.message || 'Reset link sent to your email!')
          setIsSent(true)
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          'Something went wrong. Please try again.'
        toast.error(errorMessage)
      } finally {
        setIsSubmitting(false)
      }
    },
  })

  const goToLogin = (e) => {
    e.preventDefault()
    navigate('/login')
  }

  return (
    <div className="forgot_pg_container">
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="forgot_pg_left">
        <div className="forgot_pg_logo_row">
          <img
            src={LOGO_SIDE_IMG_URL}
            alt="Rubicr HR"
            className="forgot_pg_logo_side_img"
          />
          <img
            src={LOGO_URL}
            alt="Rubicr"
            className="forgot_pg_logo_img"
          />
        </div>
      </div>

      <div className="forgot_pg_right">
        <div className="forgot_pg_form_wrap">
          {!isSent ? (
            <>
              <h2 className="forgot_pg_title">Forgot your password?</h2>
              <p className="forgot_pg_subtitle">
                Enter your registered email and we&apos;ll send you a link to reset your password.
              </p>

              <form className="forgot_pg_form" onSubmit={formik.handleSubmit} noValidate>
                <div className="forgot_pg_field">
                  <label className="forgot_pg_label" htmlFor="email">
                    Email Address <span className="forgot_pg_required">*</span>
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    className="forgot_pg_input"
                    placeholder="Enter your registered email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <span className="forgot_pg_error_text">{formik.errors.email}</span>
                  )}
                </div>

                <button type="submit" className="forgot_pg_submit_btn" disabled={isSubmitting}>
                  {isSubmitting ? 'Sending...' : (
                    <>
                      Send Reset Link <span className="forgot_pg_arrow">&rarr;</span>
                    </>
                  )}
                </button>

                <p className="forgot_pg_back_text">
                  Remembered your password?{' '}
                  <a href="/login" className="forgot_pg_back_link" onClick={goToLogin}>
                    Back to Login
                  </a>
                </p>
              </form>
            </>
          ) : (
            <div className="forgot_pg_success_wrap">
              <h2 className="forgot_pg_title">Check your inbox</h2>
              <p className="forgot_pg_subtitle">
                We&apos;ve sent a password reset link to <strong>{formik.values.email}</strong>.
                Please check your email (and spam folder) to continue.
              </p>
              <button
                type="button"
                className="forgot_pg_submit_btn"
                onClick={goToLogin}
              >
                Back to Login
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword